import request from "@/utils/request";
import qs from "qs";

/**
 * 登录【ok】
 * @param params
 * @returns {*}
 */
export function login(params) {
  return request.post("/auth/loginbypw", qs.stringify(params));
}

/**
 * 刷新权限
 */
export function refreshPermMenu() {
  return request({
    url: "/auth/refreshPermissions",
    method: "get",
    params: {}
  });
}

// export function logout() {
//   return request({
//     url: '/api/backend/user/logout',
//     method: 'post'
//   })
// }
